<div class="delete-role-dialog">
  <h2 class="headline">{{'PAYMENT_VIEW_PAGE.MODAL_DELETE_GROUP.TITLE' | translate}}</h2>
  <p class="description">{{'PAYMENT_VIEW_PAGE.MODAL_DELETE_GROUP.DESCRIPTION' | translate}}</p>
  <h3 class="subtitle">{{'PAYMENT_VIEW_PAGE.MODAL_DELETE_GROUP.DESCRIPTION_2' | translate}} {{deleteGroup.length}}</h3>
  <div class="btn-block">
    <button (click)="deleteCash()" class="btn btn-danger">
      {{'PAYMENT_VIEW_PAGE.MODAL_DELETE_GROUP.DELETE' | translate}}
    </button>
    <button (click)="closeModal()" class="btn btn-light">
      {{'PAYMENT_VIEW_PAGE.MODAL_DELETE_GROUP.CANCEL' | translate}}
    </button>
  </div>
</div>